import * as React from 'react';

import { IOfferSchema } from '@cian/api-models/offer-card/v1/get-offer-data';
import { HeatingType, WcLocationType } from '../../store/offer';
import { getOfferType, isUrban } from '../../utils/offer_type';
import * as styles from './index.css';
import { FeatureItem } from './item/index';

export interface IFeaturesProps {
  offer: IOfferSchema;
}

/* istanbul ignore next */
export class Features extends React.PureComponent<IFeaturesProps, {}> {
  public render() {
    const { offer } = this.props;
    const features = getFeaturesByOffer(offer);

    /* istanbul ignore next */
    if (features.length === 0) {
      return null;
    }

    return (
      <ul className={styles['container']}>
        {features.map(({ className, name }) => (
          <FeatureItem key={name} name={name} className={className} />
        ))}
      </ul>
    );
  }
}

export function getFeaturesByOffer(offer: IOfferSchema) {
  const features = [];
  const offerType = getOfferType(offer);

  /* istanbul ignore next */
  if (
    !isUrban(offerType) &&
    (offer.hasHeating ||
      (offer.building && offer.building.heatingType && offer.building.heatingType !== HeatingType.No))
  ) {
    features.push({
      className: 'radiator',
      name: 'Отопление',
    });
  }

  if (offer.wcLocationType) {
    const text = offer.wcLocationType === WcLocationType.Indoors ? 'в доме' : 'на улице';

    features.push({
      className: 'toilet',
      name: `Санузел ${text}`,
    });
  }

  /* istanbul ignore next */
  if (offer.hasFridge) {
    features.push({
      className: 'fridge',
      name: 'Холодильник',
    });
  }

  /* istanbul ignore next */
  if (offer.hasDishwasher) {
    features.push({
      className: 'dishwasher',
      name: 'Посудомоечная машина',
    });
  }

  /* istanbul ignore next */
  if (offer.hasWasher) {
    features.push({
      className: 'washing',
      name: 'Стиральная машина',
    });
  }

  /* istanbul ignore next */
  if (offer.hasFurniture) {
    features.push({
      className: 'furniture',
      name: 'Мебель в комнатах',
    });
  }

  /* istanbul ignore next */
  if (offer.hasKitchenFurniture) {
    features.push({
      className: 'kitchen',
      name: 'Мебель на кухне',
    });
  }

  /* istanbul ignore next */
  if (offer.hasConditioner) {
    features.push({
      className: 'cond',
      name: 'Кондиционер',
    });
  }

  /* istanbul ignore next */
  if (offer.hasTv) {
    features.push({
      className: 'tv',
      name: 'Телевизор',
    });
  }

  /* istanbul ignore next */
  if (offer.hasInternet) {
    features.push({
      className: 'internet',
      name: 'Интернет',
    });
  }

  /* istanbul ignore next */
  if (offer.hasBathtub) {
    features.push({
      className: 'bath',
      name: 'Ванна',
    });
  }

  /* istanbul ignore next */
  if (offer.hasShower) {
    features.push({
      className: 'shower',
      name: 'Душевая кабина',
    });
  }

  /* istanbul ignore next */
  if (offer.hasBathhouse) {
    features.push({
      className: 'banya',
      name: 'Баня',
    });
  }

  /* istanbul ignore next */
  if (offer.hasGarage) {
    features.push({
      className: 'garage',
      name: 'Гараж',
    });
  }

  /* istanbul ignore next */
  if (offer.hasPool) {
    features.push({
      className: 'pool',
      name: 'Бассейн',
    });
  }

  /* istanbul ignore next */
  if (offer.hasElectricity) {
    features.push({
      className: 'electricity',
      name: 'Электричество',
    });
  }

  /* istanbul ignore next */
  if (offer.hasGas) {
    features.push({
      className: 'gas',
      name: 'Газ',
    });
  }

  /* istanbul ignore next */
  if (offer.hasDrainage) {
    features.push({
      className: 'canal',
      name: 'Канализация',
    });
  }

  /* istanbul ignore next */
  if (offer.hasWater) {
    features.push({
      className: 'water',
      name: 'Водоснабжение',
    });
  }

  /* istanbul ignore next */
  if (offer.hasSecurity) {
    features.push({
      className: 'secure',
      name: 'Охрана',
    });
  }

  /* istanbul ignore next */
  if (offer.hasLight) {
    features.push({
      className: 'light',
      name: 'Свет',
    });
  }

  /* istanbul ignore next */
  if (offer.hasExtinguishingSystem) {
    features.push({
      className: 'extinguishing_system',
      name: 'Система пожаротушения',
    });
  }

  return features;
}
